import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, YAxis } from 'recharts'
import { Button } from '../ui/button'

const TABS = ['Deposit & Withdraw', 'Unstake & Claims', 'Staking history']

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

const CHART_DATA = [
	{ month: 'Jan', stake: 44 },
	{ month: 'Feb', stake: 46 },
	{ month: 'Mar', stake: 53 },
	{ month: 'Apr', stake: 62 },
	{ month: 'May', stake: 69 },
	{ month: 'Jun', stake: 70 },
	{ month: 'Jul', stake: 60 },
	{ month: 'Aug', stake: 44 },
	{ month: 'Sep', stake: 47 },
	{ month: 'Oct', stake: 44 },
	{ month: 'Nov', stake: 58 },
	{ month: 'Dec', stake: 65 },
]

export function YourStakeCard() {
	return (
		<div className='flex min-w-0 flex-1 flex-col gap-4 rounded-[14px] border border-border bg-secondary p-4 shadow-[0_4px_12px_0_hsl(var(--background)/0.2)]'>
			<h3 className='text-lg font-medium tracking-[-0.27px] text-foreground'>Your Stake BECY</h3>

			<div className='flex flex-col rounded-xl bg-background sm:flex-row sm:items-center'>
				<div className='flex flex-1 flex-col items-center gap-2 py-3 sm:py-2'>
					<span className='text-sm font-medium tracking-[-0.21px] text-muted-foreground'>You Stake</span>
					<span className='text-2xl font-semibold tracking-[-0.24px] text-foreground'>
						$ 1344
						<span className='text-base text-muted-foreground'>.75</span>
						<span className='ml-2 text-xs font-semibold text-primary'>+2.4%</span>
					</span>
				</div>
				<div className='hidden h-8 w-px bg-border sm:block' />
				<div className='h-px w-full bg-border sm:hidden' />
				<div className='flex flex-1 flex-col items-center gap-2 py-3 sm:py-2'>
					<span className='text-sm font-medium tracking-[-0.21px] text-muted-foreground'>Rewards</span>
					<span className='text-2xl font-semibold tracking-[-0.24px] text-foreground'>
						$ 5385
						<span className='text-base text-muted-foreground'>.05</span>
						<span className='ml-2 text-xs font-semibold text-primary'>+8.7%</span>
					</span>
				</div>
			</div>

			<div className='grid grid-cols-1 gap-2 sm:grid-cols-3'>
				{TABS.map((tab) => (
					<Button key={tab} variant='secondary' className='w-full sm:w-auto'>
						{tab}
					</Button>
				))}
			</div>

			<div className='flex flex-col gap-2 rounded-xl bg-background p-2'>
				<div className='h-[220px]'>
					<ResponsiveContainer width='100%' height='100%'>
						<AreaChart data={CHART_DATA} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
							<defs>
								<linearGradient id='stakeGradient' x1='0' y1='0' x2='0' y2='1'>
									<stop offset='0%' stopColor='hsl(var(--info))' stopOpacity={0.24} />
									<stop offset='100%' stopColor='hsl(var(--accent-green))' stopOpacity={0} />
								</linearGradient>
							</defs>
							<CartesianGrid stroke='hsl(var(--border))' strokeOpacity={0.35} vertical={false} />
							<YAxis
								domain={[40, 75]}
								ticks={[40, 45, 50, 55, 60, 65, 70, 75]}
								tick={{ fill: 'hsl(var(--subtle-foreground))', fontSize: 12 }}
								axisLine={false}
								tickLine={false}
								width={32}
							/>
							<Tooltip
								contentStyle={{
									background: 'hsl(var(--secondary))',
									border: '1px solid hsl(var(--border))',
									borderRadius: 10,
									color: 'hsl(var(--foreground))',
								}}
							/>
							<Area type='monotone' dataKey='stake' stroke='hsl(var(--accent-green))' strokeWidth={1.5} fill='url(#stakeGradient)' />
						</AreaChart>
					</ResponsiveContainer>
				</div>

				<div className='overflow-x-auto px-2'>
					<div className='flex min-w-[480px] items-center gap-1'>
						{MONTHS.map((month) => (
							<span key={month} className='flex-1 rounded-full bg-background py-1 text-center text-xs text-subtle-foreground'>
								{month}
							</span>
						))}
					</div>
				</div>

				<div className='flex items-center justify-center gap-2 pb-1'>
					<span className='h-2 w-2 rounded-full bg-success' />
					<span className='text-sm font-medium tracking-[-0.21px] text-muted-foreground'>Your Stake</span>
				</div>
			</div>
		</div>
	)
}
